import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMenuPermissions } from '../../contexts/MenuPermissionsContext';

/**
 * PermissionRoute component that checks if a user has permission to access a route.
 * If not, they are redirected to the home page.
 * 
 * Usage:
 * <PermissionRoute menuPath="/settings">
 *   <SettingsComponent />
 * </PermissionRoute>
 */
const PermissionRoute = ({ menuPath, children }) => {
  const { hasMenuPermission, loading } = useMenuPermissions();
  
  // While permissions are loading, show nothing
  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="w-8 h-8 border-t-2 border-b-2 border-indigo-500 rounded-full animate-spin"></div>
      </div>
    );
  }
  
  // If user doesn't have permission, redirect to home
  if (!hasMenuPermission(menuPath)) {
    return <Navigate to="/" replace />;
  }
  
  // User has permission, render the children
  return children;
};

export default PermissionRoute; 